export enum ShortcutType {
    copy = 'copy',
    paste = 'paste',
    cut = 'cut',
    editDeployment = 'editDeployment',
    newDeployment = 'newDeployment',
    normal = 'normal',
    free = 'free',
    sick = 'sick',
    extra = 'extra',
    training = 'training',
    compensationLeave = 'compensationLeave',
    specialLeave = 'specialLeave',
}
